<template>
  <a-card class="CourseChildren">
    <div :class="advanced ? 'search' : null">
      <a-form layout="horizontal" class="searchForm">
        <div :class="advanced ? null : 'fold'">
          <a-form-item label="课时名称" :labelCol="{ span: 6 }" :wrapperCol="{ span: 17, offset: 1 }">
            <a-input placeholder="请输入课时名称" v-model.trim="search.name" />
          </a-form-item>
          <span style="margin-left: 20px; margin-top: 3px">
            <a-button type="primary" @click="getList(1)">查询</a-button>
            <a-button style="margin-left: 8px" @click="resetSearch()">重置</a-button>
            <a-button @click="addEgame()" v-if="![1, 4].includes($store.getters['course/getSeriesInfo']().status)" type="primary" icon="plus" style="margin-left: 35px"> 课时 </a-button>
            <a-button icon="plus" style="margin-left: 35px" @click="uploadEvaluate()">导入评价</a-button>
            <a-button icon="plus" style="margin-left: 35px" @click="uploadCourseChild()">导入课时</a-button>
            <a-button icon="edit" style="margin-left: 35px" @click="editAllName" type="primary">重置课时名称</a-button>
          </span>
        </div>
      </a-form>
    </div>
    <div>
      <a-table
        :loading="loading"
        :columns="columns"
        :data-source="dataSource"
        class="components-table-demo-nested"
        :pagination="{
          current: search.pageIndex,
          pageSize: search.pageSize,
          total: total,
          showSizeChanger: true,
          showLessItems: true,
          showQuickJumper: true,
          showTotal: (total, range) => `第 ${range[0]}-${range[1]} 条，总计 ${total} 条`,
          onChange: onPageChange,
          onShowSizeChange: onSizeChange,
        }"
      >
        <div slot="displayOrder" slot-scope="text, record" :class="[1, 4].includes($store.getters['course/getSeriesInfo']().status) && 'no-click'">
          <input @blur="tableInputBlurDisplayOrder(record)" class="table-input" type="number" v-model="record.displayOrder" />
        </div>
        <div slot="estimatedTime" slot-scope="text, record">
          <span v-if="record.composeMode == 0">{{ EstimatedTime(record.estimatedTime) }}</span>
          <span v-else></span>
        </div>
        <!-- <div slot="name" slot-scope="text,record" class="table_div">
                    <a-icon type="exclamation-circle" theme="filled" class="table_icon" v-if="text.abnormalFlag > 0"/>
                    {{text.name }}
                </div> -->
        <div slot="name" slot-scope="text, record" class="table_div">
          <a-icon type="exclamation-circle" theme="filled" class="table_icon" v-if="text.abnormalFlag > 0" />
          <input @blur="tableInputBlurName(record)" :class="[1, 4].includes($store.getters['course/getSeriesInfo']().status) && 'no-click'" class="table-input" v-model="record.name" />
        </div>
        <div slot="type" slot-scope="text, record">
          <span v-if="record.childCourseType == 1" style="color: #1e9fff">测评课时</span>
          <span v-if="record.childCourseType == 2" style="color: #ff5722">训练课时</span>
          <span v-if="record.childCourseType == 3" style="color: #2f4056">活动课时</span>
        </div>
        <div slot="randomContentCount" slot-scope="text, record">
          {{ text.randomContentCount }}
        </div>
        <div slot="contentCount" slot-scope="text, record">
          {{ text.isOverall ? '--' : text.contentCount }}
        </div>
        <div :class="[1, 4].includes($store.getters['course/getSeriesInfo']().status) && 'no-click'" slot="status" slot-scope="text, record">
          <a-switch @change="StatusChange(record)" checked-children="启用" un-checked-children="禁用" v-model="record.enabled" />
        </div>
        <div slot="action" slot-scope="text, record" class="action">
          <a @click="content(record)">内容</a>
          <a @click="evaluate(record)" v-if="record.evaluations && record.objectives">评价</a>
          <a v-else style="color: #ccc; cursor: no-drop">评价</a>
          <a v-if="$store.getters['course/getSeriesInfo']().status !== 4">
            <em style="font-style: normal" v-if="$store.getters['course/getSeriesInfo']().status !== 1" @click="copy(record)"> 复制 </em>
            <span v-else class="no-drop">复制</span>
          </a>
          <a-popconfirm title="确定删除？" v-if="![1, 4].includes($store.getters['course/getSeriesInfo']().status)" @confirm="deleteitem(record)">
            <a class="red">删除</a>
          </a-popconfirm>
          <a v-else class="red no-drop">
            <span>删除</span>
          </a>
        </div>
      </a-table>
    </div>
    <a-modal v-model="upload.visible" title="批量导入" @ok="submit" @cancel="closeModle" :confirmLoading="upload.loading">
      <div class="um-download">
        <h4 class="um-h4">数据模板下载</h4>
        <p align="center">
          <a :href="upload.DownloadTemplate | filterUrl" class="templateDownload">点击下载模板</a>
        </p>
      </div>
      <div class="um-download" style="margin-top: 0">
        <h4 class="um-h4" style="font-size: 14px; top: -13px">批量导入评价</h4>
      </div>
      <a-upload-dragger name="file" :file-list="upload.fileList" :remove="handleRemove" :before-upload="beforeUpload" @change="uploadChange">
        <p class="ant-upload-drag-icon">
          <a-icon type="cloud-upload" />
        </p>
        <p class="ant-upload-text" style="color: #666">点击上传文件，或将文件拖拽到此处</p>
        <p class="ant-upload-hint">（支持扩展名为xlsx文件）</p>
      </a-upload-dragger>
      <a href="javascript:;" @click="downloadUploadErrorData" v-if="upload.errorData.length" style="text-align: center; margin: 20px 0; display: block; color: #f00">点击这里下载错误数据</a>
    </a-modal>
    <a-modal
      v-model="selectCourse.visible"
      width="1200px"
      class="add-resource"
      :confirm-loading="selectCourse.loading"
      :centered="true"
      :destroyOnClose="true"
      title="选择课程"
      @cancel="selectFormCancel"
    >
      <a-steps :current="selectCourse.step" size="small">
        <a-step title="选择课程" />
        <a-step title="选择课时" />
      </a-steps>
      <template slot="footer">
        <div v-if="selectCourse.step == 0">
          <a-button @click="addFormCancel"> 取消 </a-button>
          <a-button type="primary" @click="next()"> 下一步 </a-button>
        </div>
        <div v-if="selectCourse.step == 1">
          <a-button @click="back()"> 上一步 </a-button>
          <a-button type="primary" @click="submitmodal()"> 提交 </a-button>
        </div>
      </template>
      <div class="stepForm" style="margin-top: 30px">
        <div v-if="selectCourse.step == 0">
          <addCourseResource ref="addCourseResourceTable" :type="textTit" :course-type="$store.getters['course/getCourseInfo']().courseType" />
        </div>
        <div v-if="selectCourse.step == 1">
          <a-table
            :columns="courseChildcolumns"
            row-key="id"
            :row-selection="rowSelection"
            :scroll="{ y: 350 }"
            :pagination="tableRelevant.tablePagination"
            :loading="tableRelevant.tableLoading"
            :locale="tableRelevant.locale"
            :dataSource="tableRelevant.tableDataSource"
          >
            <div slot="type" slot-scope="text, record">
              <span v-if="record.childCourseType == 1" style="color: #1e9fff">测评课时</span>
              <span v-if="record.childCourseType == 2" style="color: #ff5722">训练课时</span>
              <span v-if="record.childCourseType == 3" style="color: #2f4056">活动课时</span>
            </div>
            <div slot="status" slot-scope="text, record">
              <a-switch @change="StatusChange(record)" checked-children="启用" un-checked-children="禁用" v-model="record.enabled" disabled />
            </div>
            <div slot="estimatedTime" slot-scope="text, record">
              <span v-if="record.composeMode == 0">{{ EstimatedTime(record.estimatedTime) }}</span>
              <span v-else></span>
            </div>
          </a-table>
        </div>
      </div>
    </a-modal>
  </a-card>
</template>

<script>
import { EstimatedTime } from '@/utils/EstimatedTime'
import addCourseResource from './AddCourseResource'
import { tableRelevant } from '@/pages/projectImpl/js/utils'
import MixinStting from '../mixinSetting'
import xlsx from 'xlsx-js-style'

const columns = [
  { title: '排序', scopedSlots: { customRender: 'displayOrder' }, key: 'displayOrder', align: 'center' },
  { title: '名称', scopedSlots: { customRender: 'name' }, key: 'name', align: 'center', width: 200 },
  { title: '类型', scopedSlots: { customRender: 'type' }, align: 'center' },
  { title: '评价体系', dataIndex: 'abilityEvaluationsysName', key: 'abilityEvaluationsysName', align: 'center' },
  { title: '智能内容', scopedSlots: { customRender: 'randomContentCount' }, key: 'randomContentCount', align: 'center' },
  { title: '普通内容', scopedSlots: { customRender: 'contentCount' }, key: 'contentCount', align: 'center' },
  { title: '描述', dataIndex: 'description', key: 'description', align: 'center', ellipsis: true },
  { title: '预计用时', scopedSlots: { customRender: 'estimatedTime' }, align: 'center', key: 'time' },
  { title: '备注', dataIndex: 'remark', key: 'remark', align: 'center', ellipsis: true },
  { title: '状态', scopedSlots: { customRender: 'status' }, key: 'status', align: 'center' },
  { title: '操作', key: 'action', scopedSlots: { customRender: 'action' }, align: 'center', width: 270 },
]
const courseChildcolumns = [
  { title: '课时名称', dataIndex: 'name', key: 'name', align: 'center' },
  { title: '类型', scopedSlots: { customRender: 'type' }, align: 'center' },
  { title: '状态', scopedSlots: { customRender: 'status' }, key: 'status', align: 'center' },
  { title: '预计用时', scopedSlots: { customRender: 'estimatedTime' }, align: 'center', key: 'time' },
]
export default {
  name: 'CourseChildren',
  components: {
    addCourseResource,
  },
  mixins: [MixinStting],
  data() {
    return {
      EstimatedTime,
      loading: true,
      advanced: false,
      istoggleAdvanced: false, //是否显示展开按钮
      dataSource: [],
      columns,
      total: 0,
      search: {
        pageIndex: 1,
        pageSize: 10,
        name: undefined,
        courseId: this.$route.query.id || this.$store.getters['course/getCourseInfo']().id,
      },
      upload: {
        DownloadTemplate: process.env.VUE_APP_TEMPLATE_URL + "/template/excel/综合评价内容导入模板.xlsx",
        visible: false,
        loading: false,
        file: '',
        fileList: [],
        errorData: [],
      },
      textTit: '复制',
      selectCourse: {
        visible: false,
        loading: false,
        step: 0,
        courseId: undefined,
      },
      courseChildcolumns,
      tableRelevant: tableRelevant.call(this, this.getCoursechild),
      selectionKeys: [],
    }
  },
  created() {
    this.getList(1)
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectionKeys,
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectionKeys = selectedRowKeys
        },
      }
    },
  },
  methods: {
    editAllName() {
      this.$confirm({
        title: '是否重置所有课时名称?',
        centered: true,
        content: '点击重置后，所有课时将会按照课时+排序的默认规则命名，如课时1，课时2，课时3...',
        onOk: () => {
          this.$http.CourseResource.courseSessionResetName({ courseId: this.search.courseId }).then((res) => {
            this.$message.success(res.message)
            this.getList(1)
          })
        },
      })
    },
    // 导入课时
    uploadCourseChild() {
      this.selectCourse.visible = true
    },
    selectFormCancel() {
      this.selectCourse.visible = false
    },
    addFormCancel() {
      this.selectCourse.visible = false
    },
    back() {
      this.selectCourse.step = 0
    },
    next() {
      const courseSelectedRow = this.$refs.addCourseResourceTable.$data.courseSelectedRowKeys.map((m) => JSON.parse(m))
      this.$message.destroy()
      if (!courseSelectedRow.length) {
        this.$message.error('请选择课程')
        return
      }
      this.selectCourse.step = 1
      this.selectCourse.courseId = courseSelectedRow[0]
      this.getCoursechild(1)
    },
    // 获取课时
    getCoursechild(pageIndex) {
      let params = {
        courseId: this.selectCourse.courseId,
        enabled: true,
        pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
        pageSize: this.tableRelevant.tablePagination.pageSize,
      }
      this.$http.CourseResource.getCourseSessions(params).then((res) => {
        const { data } = res
        this.tableRelevant.tableDataSource = res.data.items
        this.tableRelevant.tablePagination.total = res.data.totalCount
        this.tableRelevant.tablePagination.current = res.data.pageIndex
        this.tableRelevant.tablePagination.pageSize = res.data.pageSize
      })
    },
    submitmodal() {
      if (!this.selectionKeys.length) {
        this.$message.error('请选择课时')
        return
      }
      const Params = {
        "courseId": this.search.courseId,
        "courseSessionIds": this.selectionKeys
      }
      this.$http.CourseResource.courseSessionCopy(Params).then((res) => {
        this.$message.success('操作成功')
        this.selectionKeys = []
        this.selectCourse.step = 0
        this.selectCourse.visible = false
        this.getList()
      })
    },

    // 评价
    evaluate(record) {
      this.$router.push({
        path: '/course/manage/CourseChildren/EvaluateContent',
        query: {
          id: record.id,
        },
      })
    },
    uploadEvaluate() {
      this.upload.visible = true
    },
    // 批量导入
    handleRemove(file) {
      const index = this.upload.fileList.indexOf(file)
      const newFileList = this.upload.fileList.slice()
      newFileList.splice(index, 1)
      this.upload.fileList = newFileList
    },
    beforeUpload(file) {
      const bool = this.upload.fileList.filter((v) => v.name === file.name).length
      if (bool) {
        this.$message.warning('已有相同的文件，请重新选择文件')
        return false
      }
      this.upload.fileList = [file]
      return false
    },
    uploadChange(value) {
      if (value.fileList.length) {
        this.upload.file = value.file
      } else {
        this.upload.file = ''
      }
    },
    closeModle() {
      this.upload.visible = false
      this.upload.fileList = []
      this.upload.file = ''
      this.upload.errorData = []
    },
    submit() {
      if (this.upload.file) {
        this.upload.loading = true
        const formData = new FormData()
        formData.append('file', this.upload.file)
        formData.append('courseId', this.search.courseId)
        this.$http.CourseResource.courseSessionImportEvaluations(formData).then((res) => {
          this.getList(1)
          this.$message.success(res.message)
          this.upload.visible = false
          this.upload.fileList = []
          this.upload.file = ''
          this.upload.errorData = []
        }).catch(e => {
          if (Array.isArray(e.data)) {
            this.upload.errorData = e.data
          }
        }).finally(() => {
          this.upload.loading = false
        })
      } else {
        this.$message.destroy()
        this.$message.warning('请选择xlsx文件')
      }
    },
    downloadUploadErrorData() {
      const titleList = ["课时排序‌", "课前名称‌", "知识掌握题目壳1", "情感态度题目壳1", "课后名称", "知识掌握题目壳2", "情感态度题目壳2", "教师评价题目壳2"];
      const list = [titleList].concat(this.upload.errorData.map((m, i) => {
          const data = [
            m.displayOrder,
            m.stageName1,
            m.knowledgeQuestionName1,
            m.emotionQuestionName1,
            m.stageName2,
            m.knowledgeQuestionName2,
            m.emotionQuestionName2,
            m.teacherQuestionName2,
          ];
          m.objectives.forEach(f => {
            data.push(f.objectiveName);
            data.push(f.objectiveContent);
            if (i === 0) {
              titleList.push("目标标题");
              titleList.push("目标内容");
            }
          });
          data.push(m.messageList.join('\n'))
          return data;
        }));
      titleList.push("错误信息");

      // 创建一个新的工作簿
      const workbook = xlsx.utils.book_new();
      // 将数据转换为工作表
      const worksheet = xlsx.utils.aoa_to_sheet(list);
      // 设置列宽
      const cols = [];
      // 设置内容样式
      Object.keys(worksheet).forEach(f => {
        if (typeof worksheet[f] !== 'object') {
          return;
        }
        worksheet[f].s = {
          font: {
            sz: 12,
            color: { rgb: '000000' }
          },
          alignment: {
            horizontal: 'center',
            vertical: 'center'
          }
        };
      });
      // 设置表头样式
      titleList.forEach((f, i) => {
        const ex = xlsx.utils.encode_cell({ r: 0, c: i });
        worksheet[ex].s = {
          font: {
            sz: 12,
            bold: true,
            color: { rgb: worksheet[ex].v === '错误信息' ? 'FF0000' : '000000' }
          },
          fill: {
            fgColor: { rgb: 'eeeeeeff' } // 背景
          },
          border: {
            top: { style: 'thin', color: { rgb: '000000' } }, // 上边框
            bottom: { style: 'thin', color: { rgb: '000000' } }, // 下边框
            left: { style: 'thin', color: { rgb: '000000' } }, // 左边框
            right: { style: 'thin', color: { rgb: '000000' } } // 右边框
          },
          alignment: {
            horizontal: 'center',
            vertical: 'center'
          }
        };
        // 设置列宽
        cols.push({ wpx: worksheet[ex].v === '错误信息' ? 250 : 120 });
      })
      // 设置列宽
      worksheet['!cols'] = cols;
      // 设置行高
      worksheet['!rows'] = list.map(m => ({ hpt: 23 }));
      // 将工作表添加到工作簿中
      xlsx.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
      // 将工作簿导出为 Excel 文件
      xlsx.writeFile(workbook, '导入评价错误数据.xlsx');
    },
    // 修改课时名称
    tableInputBlurName(record) {
      let str = {
        id: record.id,
        name: record.name,
      }
      this.$message.destroy()
      this.$http
        .updateCourseChildName(str)
        .then((res) => {
          this.loading = false
          this.$message.success(res.data.message||'操作成功')
          this.getList(1)
        })
        .catch((err) => {
          this.loading = false
        })
    },
    // 修改displayOrder
    tableInputBlurDisplayOrder(record) {
      if (!/(^[1-9]\d*$)/.test(record.displayOrder)) {
        this.$message.destroy()
        this.$message.error('请输入正整数')
        this.getList()
        return
      }
      this.loading = true
      let str = {
        id: record.id,
        displayOrder: +record.displayOrder,
      }
      this.$message.destroy()
      this.$http
        .CourseResource.updateDisplayOlder(str)
        .then((res) => {
          this.loading = false
            this.$message.success(res.message||'操作成功')
            this.getList(1)
        })
        .catch((err) => {
          this.loading = false
        })
    },
    resetSearch() {
      this.search = {
        pageIndex: 1,
        pageSize: 10,
        name: undefined,
        courseId: sessionStorage.getItem('currentId'),
      }
      this.getList(1)
    },
    // 配置
    content(record) {
      sessionStorage.setItem('courseChildItem', JSON.stringify(record))
      sessionStorage.setItem('addChildrenId', record.id)
      this.$router.push({
        path: '/course/manage/CourseChildren/ChildrenCourseContent',
        query: {
          id: record.id,
          type: 'edit',
          childCourseType: record.childCourseType,
          courseId: this.$route.query.id || this.$store.getters['course/getCourseInfo']().id,
        },
      })
    },
    // 复制
    copy(record) {
      const Params = {
        "courseId": this.$route.query.id || this.$store.getters['course/getCourseInfo']().id,
        "courseSessionIds": [record.id]
      }
      this.$http.CourseResource.courseSessionCopy(Params).then((res) => {
        this.$message.destroy()
        this.$store.dispatch('course/setCourseStatus')
        this.$message.success('复制成功')
        sessionStorage.setItem('copycoursechildId', res.data[0])
        sessionStorage.setItem('addChildrenId', res.data[0])
        sessionStorage.setItem('copycoursechildName', record.name)
        this.$router.push({
          path: '/course/manage/CourseChildren/ChildrenCourseContent',
          query: {
            type: 'edit',
            id: res.data[0],
            courseId: this.$route.query.id || this.$store.getters['course/getCourseInfo']().id,
          },
        })
      })
    },
    StatusChange(record) {
      this.$message.destroy()
      let formData = new FormData()
      formData.append('id', record.id)
      this.loading = true
      this.$http.courseChildCheckStatus(formData).then((res) => {
        const { message } = res.data
          this.$http.CourseResource.courseSessionStatus({ id: record.id }).then((res1) => {
            this.$message.success('修改成功')
          }).catch((err) => {
            record.enabled = !record.enabled
          })
      }).finally(() => {
        this.loading = false
      })
    },
    deleteitem(record) {
      this.$http.CourseResource.courseSessionDelete(record.id).then((res) => {
        this.$message.success('删除成功')
        if (this.dataSource.length <= 1 && this.search.pageIndex > 1) {
          this.search.pageIndex -= 1
        }
        this.getList()
        this.$store.dispatch('course/setCourseStatus')
      })
    },
    addEgame() {
      sessionStorage.removeItem('addChildrenId')
      this.$router.push({
        path: '/course/manage/CourseChildren/ChildrenCourseContent',
        query: {
          // id:record.id,
          type: 'add',
          courseId: this.$route.query.id || this.$store.getters['course/getCourseInfo']().id,
        },
      })
    },
    getList(page) {
      this.loading = true
      if (page) {
        this.search.pageIndex = page
      }
      const Params = {
        ...this.search,
        name: this.search.name || undefined
      }
      this.$http.CourseResource.getCourseSessions(Params).then((res) => {
        this.dataSource = res.data.items
        let arr = [] //排序数组
        this.dataSource.forEach((el) => {
          arr.push(el.displayOrder)
        })
        sessionStorage.setItem('maxOrder', Math.max(...arr))
        this.total = res.data.totalCount
        })
        .finally(() => {
          this.loading = false
        })
    },
    onPageChange(page, size) {
      this.search.pageIndex = page
      this.getList()
    },
    onSizeChange(page, size) {
      this.search.pageIndex = 1
      this.search.pageSize = size
      this.getList()
    },
  },
}
</script>

<style scoped>
.CourseChildren >>> .standard-table .alert {
  display: none !important;
}

.CourseChildren >>> .searchForm {
  display: flex;
}

.CourseChildren >>> .searchForm .fold {
  width: 91%;
  display: flex;
}
</style>
<style scoped lang="less">
.f_box {
  display: flex;
  flex-wrap: wrap;
  .ant-form-item {
    width: 50%;
  }
}
.table_div {
  display: flex;
  align-items: center;
  justify-content: center;
}
.table_icon {
  color: #ff9904;
  font-size: 24px;
  margin-right: 5px;
}
.table-input {
  border: none;
  width: 100%;
  height: 100%;
  display: block;
  background: transparent;
  outline: none;
  text-align: center;
}
.nocenter {
  text-align: left;
}

input[type='number'] {
  -moz-appearance: textfield;
}

input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.um-download {
  border-top: 2px solid #eee;
  height: 60px;
  position: relative;
  margin-top: 30px;

  .um-h4 {
    padding: 0 10px;
    position: absolute;
    left: 20px;
    top: -15px;
    background-color: #fff;
    font-size: 16px;
  }

  p {
    line-height: 60px;
  }
}

.um-upload {
  font-size: 16px;
  position: absolute;
  left: 30px;
  top: 5px;
}

.um-form {
  padding: 0 24px;
}

.add-resource /deep/ .ant-modal {
  width: 60%;
  min-width: 1100px;
}
</style>
